import styled from 'styled-components';
import slide4 from 'assets/images/desktop/slide4.jpg';
export { Subtitle } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Image = styled.img.attrs({ src: slide4 })`
  height: 100%;
`;
